import muster from '@dbk-legacy/muster';

export default () => muster()
  .match('app.user.entitlement[{keys:resourceId}].read',
    (requests) =>
      requests.map(({ req, res }) =>
        res.redirect(
          `roster.data.entitlement["${req.params.resourceId}"].read`
        )));
